(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-trend-report"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-sharethis]');
    if (btn) {
      const modal = btn.parentElement.querySelector('[data-sharethis-modal]');
      modal.classList.toggle('visible');
    } else {
      // Close all modals if click outside
      document.querySelectorAll('[data-sharethis-modal].visible').forEach((m) => {
        if (!m.contains(e.target)) {
          m.classList.remove('visible');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blogs-trend-report-hero"]) return;
  try {
    
function getCurrentPage() {
    const params = new URLSearchParams(window.location.search);
    const p = parseInt(params.get('page'), 10);
    return (isNaN(p) || p < 1) ? 1 : p;
  }
let currentPage  = getCurrentPage();
if (currentPage > 1 ) {
  $('.trend-feature-blog').hide();
}
else{
  $('.trend-feature-blog').show();
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-blog-meta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-sharethis]');
    if (btn) {
      const modal = btn.parentElement.querySelector('[data-sharethis-modal]');
      modal.classList.toggle('visible');
    } else {
      // Close all modals if click outside
      document.querySelectorAll('[data-sharethis-modal].visible').forEach((m) => {
        if (!m.contains(e.target)) {
          m.classList.remove('visible');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqblock"] && !Shopify.designMode) return;
  try {
    
/* FAQ Section JavaScript */
/* Add any interactive functionality if needed */

  } catch(e) { console.error(e); }
})();
})();
